export default "__VITE_ASSET__Donvknlp__"